import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ItemChanged } from '../interfaces/item-changed.interface';
import { OptionsGroup } from './interfaces/options-group.interface';

@Component({
    selector: 'dcl-options-groups',
    templateUrl: './options-groups.component.html',
    styleUrls: ['./options-groups.component.scss']
})
export class OptionsGroupsComponent {
    @Input() optionsGroups: OptionsGroup[];
    @Output() onChangedItem: EventEmitter<ItemChanged> = new EventEmitter();
    @Output() lastItemTabbed = new EventEmitter<KeyboardEvent>();

    /**
     * Receives the items id that selected value in the optionItemComponent and append the type
     * @param itemSelected
     * @param group
     */
    onItemChanged(item: ItemChanged, groupType: string): void {
        this.onChangedItem.emit({
            ...item,
            groupType
        });
    }
}
